module.exports = __webpack_public_path__ + "static/media/truck-semi.1d84d39a.png";